import { Skeleton } from 'antd';

import { useGetMobileAppBannerQuery } from '@shared/services/sitecore';

const MobileAppBanner = () => {
  const { data, isLoading } = useGetMobileAppBannerQuery();

  const withProtocol = (url?: string) => (url && !/^https?:\/\//i.test(url) ? `https://${url}` : url);

  const [hhIcon, appStoreIcon, googlePlayIcon] = data?.callToActions || [];

  if (isLoading) {
    return <Skeleton.Button active className="h-72 w-full" />;
  }

  if (!data) {
    return null;
  }

  return (
    <div className="relative overflow-hidden bg-functional-haze">
      <div className="z-10 absolute right-0 top-0 hidden size-full justify-end lg:flex">
        <img
          alt={data?.desktopBannerImageAltText}
          className="size-full object-cover lg:object-right"
          src={withProtocol(data?.desktopBannerImage)}
        />
      </div>

      <div className="z-10 absolute right-0 top-0 flex size-full items-end justify-center lg:hidden">
        <img
          alt={data?.mobileBannerImageAltText}
          className="size-full object-cover"
          src={withProtocol(data?.mobileBannerImage)}
        />
      </div>

      <div className="mx-auto w-full px-[13px] min-[576px]:box-content min-[576px]:max-w-[540px] min-[768px]:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px] min-[1400px]:max-w-[1296px]">
        <div className="-mx-3 flex flex-wrap">
          <div className="relative w-full px-3 max-[991px]:ml-auto min-[768px]:w-1/2">
            <div className="z-20 relative m-0 flex w-full flex-col items-end py-12 text-center max-[991px]:mb-[200px] max-[575px]:mb-0 lg:items-start lg:py-20 lg:text-left min-[1400px]:ml-[200px] min-[1400px]:py-16">
              <div className="mt-0 pb-6 text-base leading-6 text-functional-black max-[768px]:mb-12 min-[576px]:max-[767px]:ml-[72px] min-[576px]:max-[767px]:p-[0_72px_72px_72px]">
                <h2 className="m-0 pb-2 text-[24px]/[28px] font-semibold text-functional-black max-[575px]:px-12 max-[575px]:text-[22px]/[26px] xl:text-[1.75rem]/[2.25rem]">
                  {data?.title}
                </h2>
                <p className="m-0 text-base">{data?.subHeading}</p>
              </div>

              <div className="flex flex-col items-start gap-4 pt-4 min-[768px]:w-full min-[768px]:flex-row min-[768px]:items-center">
                <a
                  className="flex items-center justify-center rounded-2xl bg-white shadow-[0_4px_24px_0_rgba(0,0,0,0.07)]"
                  href={hhIcon?.url}
                  target={hhIcon?.target}
                >
                  <img alt={hhIcon?.altText} src={withProtocol(hhIcon?.image)} />
                </a>

                <a className="flex pb-[6px]" href={appStoreIcon?.url} rel="noreferrer" target={appStoreIcon?.target}>
                  <img alt={appStoreIcon?.altText} src={withProtocol(appStoreIcon?.image)} />
                </a>

                <a
                  className="flex pb-[6px]"
                  href={googlePlayIcon?.url}
                  rel="noreferrer"
                  target={googlePlayIcon?.target}
                >
                  <img alt={googlePlayIcon?.altText} src={withProtocol(googlePlayIcon?.image)} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppBanner;
